// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3pnSr","notes":"Notes_notes__34SU7","note":"Notes_note__2UtfS","markdown":"Notes_markdown__21hLQ"};